import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=aeb32c6c&scoped=true&lang=html"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb32c6c",
  null
  
)

export default component.exports